import locales from './../../content.json';
import store from '../../store';

function getUserLang() {
  let lang = store.getState().forceLang || window.navigator.language.slice(0, 2);
  const supportedLangs = ['en', 'ru', 'es', 'fr', 'de', 'pt', 'it', 'tr', 'pl', 'uk'];

  // if (store.getState().forceLang) {
  //   for (const [key] of Object.entries(locales)) {
  //     if (key === lang) {
  //       document.querySelector('html').setAttribute('lang', lang);
  //       return lang;
  //     }
  //   }
  // }

  if (!supportedLangs.includes(lang)) {
    lang = 'en';
  }

  document.querySelector('html').setAttribute('lang', lang);
  return lang;

  // if (forceEng) {
  //     document.querySelector('html').setAttribute('lang', 'en');
  //     return 'en'

  // if (forceEng) {
  //   document.querySelector('html').setAttribute('lang', 'en');
  //   return 'en';
  // } else {
  //   for (const [key] of Object.entries(locales)) {
  //     if (key === lang) {
  //       document.querySelector('html').setAttribute('lang', lang);
  //       return lang;
  //     }
  //   }

  //   document.querySelector('html').setAttribute('lang', 'en');
  //   return 'en';
  // }
}

export default function setUserLang({ forceEng }) {
  window.userLang = getUserLang(forceEng);
}
